import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import RadioBounce from './components/RadioBounce';
import Spirograph from './components/Spirograph';
import styles from './App.module.css';
import './App.css';

function Navigation() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isSpirograph = location.pathname === '/spirograph';

  return (
    <nav className={styles.nav}>
      <div className={styles.navContainer}>
        <span className={styles.experimentsLabel}>Experiments:</span>
        <Link 
          to="/" 
          className={`${styles.link} ${isHome ? styles.linkActive : ''}`}
        >
          Radio bounce
        </Link>
        <Link 
          to="/spirograph" 
          className={`${styles.link} ${isSpirograph ? styles.linkActive : ''}`}
        >
          Spirograph
        </Link>
      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation */}
        <Navigation />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<RadioBounce key="radio-bounce" />} />
          <Route path="/spirograph" element={<Spirograph key="spirograph" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 